/* istanbul ignore file */
export { TabsComponentsModule } from './tabs-components.module';
export { TabsComponent } from './tabs/tabs.component';
export { TabComponent } from './tab/tab.component';
